import { $$, byId } from "@utils/dom";
import { DATA_ATTR } from "@constants/data-attributes";
import { CSS } from "@constants/css-classes";

/**
 * Initialize tab navigation functionality
 */
export function initTabs(): void {
  const tabContainers = $$(DATA_ATTR.TABS);

  tabContainers.forEach((container) => {
    const tabs = $$<HTMLElement>("[role='tab']", container);
    const panels = $$<HTMLElement>("[role='tabpanel']", container);

    // Read classes from data attributes or use defaults
    const activeClasses = container.dataset.tabActive?.split(" ").filter(Boolean) ?? [CSS.BG_CARD, CSS.TEXT_FOREGROUND];
    const inactiveClasses = container.dataset.tabInactive?.split(" ").filter(Boolean) ?? [CSS.TEXT_MUTED_FOREGROUND];

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        // Deactivate all tabs
        tabs.forEach((t) => {
          t.setAttribute("aria-selected", "false");
          t.classList.remove(...activeClasses);
          t.classList.add(...inactiveClasses);
        });

        // Hide all panels
        panels.forEach((p) => {
          p.classList.add(CSS.HIDDEN);
        });

        // Activate clicked tab
        tab.setAttribute("aria-selected", "true");
        tab.classList.add(...activeClasses);
        tab.classList.remove(...inactiveClasses);

        // Show corresponding panel
        const panelId = tab.getAttribute("aria-controls");
        if (panelId) {
          const panel = byId(panelId);
          panel?.classList.remove(CSS.HIDDEN);
        }
      });
    });
  });
}
